<template>
    <div class="wrap">
      <div class="btn down" @click="toDownload()">异常修复</div>
      <img class="bg" src="@/assets/img/bg.png" alt="bg" />
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
      }
    },
    mounted() {
      document.title = 'IM异常修复'
    },
    methods: {
      toDownload(){
        let query = this.$route.query
        let url = query.scheme+'://?gateway='+query.gateway

        window.location.href = url
      }
    },
  }
  </script>
  
  <style lang="scss" scoped>
  .wrap {
    position: relative;
    max-width: 768px;
    margin: 0 auto;
  }
  .bg {
    width: 100%;
  }
  .btn {
    width: 275px;
    height: 82px;
    position: absolute;
    bottom: 45px;
    left: 50%;
    transform: translate(-50%);
    box-shadow: 0 5px 8px 0 rgba(57, 43, 8, 0.26);
    border-radius: 16.8px;
    &:hover {
      cursor: pointer;
    }
  }
  .down {
    font-size: 40px;
    text-align: center;
    /* line-height: 60px; */
    /* margin-top: 10px; */
    /* padding-top: 10px; */
    line-height: 82px;
  
    /* color: #ff9; */
    background: darkgoldenrod;
    color: #edd;
  }
  </style>
  